import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { environmentConfig } from '../../environment';
import { Observable, throwError, catchError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WelaraAcademyService {
  private apiUrl = environmentConfig.apiBaseUrl;

  constructor(private http: HttpClient) {}

  private fetchAuthenticated(
    url: string,
    method: 'GET' | 'POST' | 'PUT',
    token: string,
    bodyData?: any
  ): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    });
    const httpOptions = { headers };
    let httpCall: Observable<any>;
    if (method === 'GET') {
      httpCall = this.http.get(url, httpOptions);
    } else if (method === 'POST') {
      httpCall = this.http.post(url, bodyData, httpOptions);
    } else if (method === 'PUT') {
      httpCall = this.http.put(url, bodyData, httpOptions);
    } else {
      return throwError(() => new Error('Unsupported method'));
    }
    return httpCall.pipe(
      catchError(error => {
        console.error('❌ HTTP Error:', error);
        return throwError(() => error);
      })
    );
  }

  saveAcademyAsset(asset: any,token:string): Promise<any> {
    return this.fetchAuthenticated(`${this.apiUrl}/api/academy/save_academy_asset`,'POST',token, asset).toPromise();
  }

  loadAcademyAssets(token: string): Promise<any> {
    const params:any = {mode:"all",active:"1"}
    return this.fetchAuthenticated(`${this.apiUrl}/api/academy/uxdata`, 'POST', token, params).toPromise();
  }
}
